import { NgModule } from '@angular/core';
import { NavigationSelectComponent } from './navigation-select.component';
import { MsSelectModule } from '../../../../shared/components/ms-select/ms-select.module';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [CommonModule, MsSelectModule],
	declarations: [NavigationSelectComponent],
	exports: [NavigationSelectComponent],
})
export class NavigationSelectModule {}
